<template>
  <div v-if="products?.length" class="s-geo-product-categories">
    <SHeading centered level="2" size="2">
      {{ tr("main_site.company_wall.geo_product_category.products_title") }}
    </SHeading>
    <p class="s-geo-product-categories__description">
      {{
        tr("main_site.company_wall.geo_product_category.products_description")
      }}
    </p>
    <SButtonList :items="products" :max-items="12" />
  </div>

  <template v-else-if="status !== 'error'">
    <SHeadingSkeleton size="2" width="60%" />
    <STextSkeleton font-size="lg" width="25rem" />
    <SButtonListSkeleton />
  </template>
</template>

<script setup lang="ts">
import { useQuery } from "@pinia/colada";
import { computed } from "vue";

import { ziggyUnsafe } from "@solvari/common-fe/integrations";
import { useI18nMainSiteCompanyWall } from "@solvari/translations";
import { getEnv, handleQuery } from "@solvari/utils";

import { useGeoProductCategories } from "@/api/localSearch.ts";
import SHeading from "@/atoms/SHeading.vue";
import SHeadingSkeleton from "@/atoms/SHeadingSkeleton.vue";
import STextSkeleton from "@/atoms/STextSkeleton.vue";
import SButtonList from "@/organisms/SButtonList/SButtonList.vue";
import SButtonListSkeleton from "@/organisms/SButtonList/SButtonListSkeleton.vue";

const { tr } = useI18nMainSiteCompanyWall();

const localeCode = getEnv().config.localeCode;

const { data, status } = useQuery(
  useGeoProductCategories({ localeCode }, handleQuery),
);

const products = computed(() =>
  data.value?.map((item) => ({
    ...item,
    href: ziggyUnsafe("client.slug", { slug: item.slug }),
  })),
);
</script>

<style lang="postcss">
.s-geo-product-categories {
  &__description {
    @apply mb-6 text-center text-lg text-slate-700;

    &::first-letter {
      @apply uppercase;
    }
  }
}
</style>
